require('./bootstrap');

window.Vue = require('vue');

import { createApp } from 'vue'

const app = createApp({

    el: '#website-app',

    data(){
        return {
            dialogLegal: null,
            dialogPolitique: null,
            dialogExpert: null,
            navbar: null,
            departement: null,
            departements: [],
            expertError: null,

            preloadProgress: 0,
            currentImageIdx: 1,
        }
    },

    mounted(){

        this.dialogLegal = $('#website-app').find('#dialog-legal');
        this.dialogPolitique = $('#website-app').find('#dialog-politique');
        this.dialogExpert = $('#website-app').find('#dialog-expert');
        this.navbar = $('#website-app').find('.navbar-collapse');

        this.readDepartements();
        this.startDiaporama();

        this.preloadImages([
            "http://dvi-ceif.fr/images/back1.jpg",
            "http://dvi-ceif.fr/images/back2.jpg",
            "http://dvi-ceif.fr/images/back3.jpg",
            "http://dvi-ceif.fr/images/back4.jpg",
            "http://dvi-ceif.fr/images/back6.jpg",
        ]);
    },

    methods: {
        readDepartements(){
            return axios.get('departements').then(r => {
                this.departements = r.data;
            });
        },

        annuaireLinkFor(departement){
            if(departement === '2A' || departement === '2B'){
                departement = '20';
            }
            return 'https://www.experts-fnaim.org/annuaire?AdresseDepartement=' + departement + '&result=1';
        },

        startDiaporama(){
            let elt = $('#website-app').find("#intro");
            let self = this;
            setInterval(function(){
                let nextIdx = self.currentImageIdx + 1;
                if(nextIdx > 6){
                    nextIdx = 1;
                }
                elt.find('.image-' + self.currentImageIdx).fadeOut('slow');
                elt.find('.image-' + nextIdx).fadeIn('slow');
                //console.log("Showing image ", nextIdx);
                self.currentImageIdx = nextIdx;
            }, 4000);
        },

        openExpert(){
            this.expertError = null;
            this.dialogExpert.modal('show');
        },

        openLegal(){
            this.dialogLegal.modal('show');
        },

        openPolitique(){
            this.dialogPolitique.modal('show');
        },

        checkExpertsLink(event){
            this.expertError = null;
            if(this.departement === null){
                event.preventDefault();
                this.expertError = true;
            }
        },

        //-----------------------------------------------------------------------------
        //      Preload images
        //-----------------------------------------------------------------------------
        loadImage(path, index, callback)
        {
            var image = new Image();
            image.onload = function(){
                if(typeof callback === 'function')
                    callback.call(this, path, index);
            };
            image.src = path;
        },

        loadImages(paths, step_callback, final_callback, debug)
        {
            var loaded_counter = 0;
            for(var i=0; i<paths.length; ++i)
            {
                this.loadImage(paths[i], i, function(path, i){
                    ++loaded_counter;
                    
                    if(debug){
                        console.log(loaded_counter + '/' + paths.length + " Image loaded : " + path + ' (' + this.width + 'x' + this.height +')');
                    }
                    
                    if(typeof step_callback === 'function')
                    {
                        step_callback.call(this, loaded_counter, paths.length);
                    }
                    
                    if(loaded_counter == paths.length)
                    {
                        if(typeof final_callback === 'function')
                        {
                            if(debug){
                                console.log("=> All images loaded");
                            }
                            final_callback.call(this);
                        }
                    }
                });
            }
        },

        preloadImages(images){
            var images_paths = images;
            let self = this;
            this.loadImages(
                images_paths,
                function(index, total){
                    self.preloadProgress = index / total;
                },
                function(){
                    self.preloadProgress = 1;
                },
                true
            );
        }

    }
});

app.mount('#website-app');
